// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__bOCKT","hideNav":"Nav_hideNav__6t-zT","logo":"Nav_logo__FVs4C","navIcons":"Nav_navIcons__vzChk","active":"Nav_active__SY8as"};